import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { getSellersForDropdown } from "api/api";

function SellersDropdown({setShow, setSelected, setAction}) {
    const [sellers, setSellers] = useState(null);
    let organizerOptions;

    useEffect(() => {
        const loadSellers = async () => {
            try {
                const res = await getSellersForDropdown();
                setSellers(res);
            } catch (err) {
                console.log(JSON.stringify(err));
            }
        };

        loadSellers();
    }, []);

    if (sellers){
        organizerOptions = sellers.map((level) => {
            const data = {value : level.company_id, label: level.name}
            return data;
        });
        organizerOptions.sort((a, b) => (a.label > b.label) ? 1 : -1);
    }
    const handleChange = target => {
        setShow(true)
        setAction('Create Demo');
        setSelected(target)
    }
    // console.log(organizerOptions, "these are the levels inside the Seniority Dropdown");
    return ( 
        <Select 
            closeMenuOnSelect={true}
            options={organizerOptions}
            placeholder={"Select a seller to create a demo"}
            classNamePrefix="react-select"
            onChange={value => handleChange(value)}
        />
    );
}

export default SellersDropdown;